import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Redirect, Route } from 'react-router-dom'
import { routes } from '../../constantes/routes'
import { TOKEN_KEY } from '../../constantes/localStorageKeys'
import { authActions } from '../../actions/authActions'

const LoginRoute = ({
    component: Component,
    ...rest
}) => {
    const userProfile = useSelector(state => state.userProfile)

    const dispatch = useDispatch()
    const login = () => dispatch(authActions.getUserProfileAuth())


    useEffect(() => {
        login()
    }, [])

    return (
        <Route
            {...rest}
            render={props =>
                localStorage.getItem(TOKEN_KEY) && userProfile.id_Usuario ? (
                    <Redirect to={{ pathname: routes.MAIN }} />
                ) : (
                        <Component {...props} />
                    )
            }
        />
    )
}

export default LoginRoute
